module.exports = __webpack_public_path__ + "img/iconfont.efa4df81.svg";